import { z } from 'zod';

export const schemaEuropaceAntragstellerIdentifikation = z.object({
    antragstellername: z.string().optional(),
    qesUrl: z.string().optional(),
    referenznummer: z.string().optional(),
    videolegitimationUrl: z.string().optional(),
});

export type SchemaEuropaceAntragstellerIdentifikation = z.infer<typeof schemaEuropaceAntragstellerIdentifikation>;
